import React from 'react';

// Overlay "AGOTADO" reutilizable para las tarjetas de producto.
// Se muestra cuando el producto tiene available === false (marcado como
// "No disponible" en el backoffice). pointer-events-none para no interferir
// con el click de ver imagen en lightbox.
const SoldOutBadge = () => (
  <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/45 pointer-events-none">
    <span className="bg-red-600 text-white px-4 py-1.5 rounded-full font-bold text-sm shadow-lg border-2 border-white tracking-wide">
      AGOTADO
    </span>
  </div>
);

export default SoldOutBadge;
